import { useQuery } from '@tanstack/react-query';
import {
  getSoftwareRepoStatus,
  SoftwareRepoStatus,
} from '@/services/workflow/get-software-repo-status';
import { useOrgStore } from '@/stores/org-store';

export const SOFTWARE_REPO_STATUS_QUERY_KEY = 'software-repo-status';

export const useSoftwareRepoStatus = (enabled = true) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<SoftwareRepoStatus, Error>({
    queryKey: [SOFTWARE_REPO_STATUS_QUERY_KEY, orgId],
    queryFn: () => getSoftwareRepoStatus(orgId as string),
    enabled: !!orgId && enabled,
    retry: false,
  });
};
